var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,null,{ hasError: _vm.hasError, err: _vm.err, info: _vm.info, resetError: _vm.resetError })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }